import * as React from "react";
import styled from "styled-components";
import { EmptyList } from "security-app/components/common";
import { GLCheckbox, RowTitleButton } from "common/components";
const TD = styled.td`
  padding: 8px 6px !important;
`;
function ListRows({ notificationOptions, notificationId, setNotificationId }) {
  const selectNotification = (newNotification) => () => {
    setNotificationId(newNotification.id);
  };
  return notificationOptions.length < 1 ? /* @__PURE__ */ React.createElement(
    EmptyList,
    {
      noSearchResultText: "No Notifications found for the provided criteria",
      noEntitiesExist: "Currently there are no Notifications to list",
      colSpan: 4
    }
  ) : /* @__PURE__ */ React.createElement(React.Fragment, null, notificationOptions.map((notification) => {
    var _a;
    return /* @__PURE__ */ React.createElement("tr", { key: notification.id }, /* @__PURE__ */ React.createElement(TD, null, /* @__PURE__ */ React.createElement(GLCheckbox, { checked: notification.id === notificationId, onChange: selectNotification(notification) })), /* @__PURE__ */ React.createElement(TD, null, /* @__PURE__ */ React.createElement(RowTitleButton, { onClick: selectNotification(notification) }, notification.title)), /* @__PURE__ */ React.createElement(TD, null, notification.description), /* @__PURE__ */ React.createElement(TD, null, (_a = notification.config) == null ? void 0 : _a.type));
  }));
}
export default ListRows;
